import {
  type IBasketProduct,
  type ILeadSession,
  type IMessage,
  type IMessengerLead,
} from '@mahawi/eshop-common/src/types';

export interface LeadMessenger extends IMessengerLead {
  unread?: number;
  isActive?: boolean;
}

export interface IMessengerState {
  inProcess: boolean;
  leads?: LeadMessenger[];
  lead: {
    uuid?: string;
  };
  messages: IMessage[];
  sessions?: ILeadSession[];
  basketProducts?: IBasketProduct[];
  message: string;
  lastMessage: {
    uuid: string;
  };
  updatedAt?: number;
  pendingLeads: Record<string, number>;
}

export enum ELeadFilter {
  ENGAGED = 'engaged',
  ALL = 'all',
}
